<div class="mx-auto">
  <router-outlet></router-outlet>
</div>
